const RUSTIC_MEDIA_PATH = "/media/rustic/";
const MEDIA_CACHE_VERSION = "20260803-full-original-restore";

export function withRusticMediaVersion(url) {
  if (!url || typeof url !== "string") return url;
  if (!url.includes(RUSTIC_MEDIA_PATH)) return url;
  if (url.includes(`v=${MEDIA_CACHE_VERSION}`)) return url;

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}v=${MEDIA_CACHE_VERSION}`;
}

export function normalizeRusticMediaProduct(product) {
  if (!product || typeof product !== "object") return product;

  return {
    ...product,
    image: withRusticMediaVersion(product.image),
    variants: Array.isArray(product.variants)
      ? product.variants.map((variant) => ({
          ...variant,
          variantImage: withRusticMediaVersion(variant.variantImage),
          image: withRusticMediaVersion(variant.image),
        }))
      : product.variants,
  };
}
